import React, { FC, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { EPromotionTypes, IState } from "store/store.interface";
import { setLocation } from "store/actions/auth.actions";
import { Box, Button, Card, Select } from "common";
import { setBundlePromotionType } from "store/actions/bundlePromotion.actions";
import { clearApi } from "store/actions/api.actions";
import { BUNDLE_PROMOTION_CREATE } from "store/store.types";

interface SelectCampaignProps {
  onFinish: () => void;
}
const SelectBundleOptions: FC<SelectCampaignProps> = ({ onFinish }) => {
  const {
    selectOptions: { bundlePromotionTypes = [] },
    countryFeatures: { freeGiftCountries = [] } = {},
    storeId,
  } = useSelector((state: IState) => ({ ...state.config,...state.auth}));

  const dispatch = useDispatch();
  const [bundleOptionType, setBundleOptionType] = useState<string>("");
  const onChangeCampaignType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBundleOptionType(event.target.value);
  };

  const onNextHandler = useCallback(() => {
    if ([EPromotionTypes.BUNDLE_CAMPAIGN, EPromotionTypes.FREE_GIFT].includes(bundleOptionType as EPromotionTypes)) {
      dispatch(
        setBundlePromotionType(
          bundleOptionType as EPromotionTypes
        )
      );
      dispatch(setLocation("/cart-bundle-create"));
      dispatch(clearApi(BUNDLE_PROMOTION_CREATE));
    }
    if (bundleOptionType === EPromotionTypes.CREATE_BULK_CAMPAIGN) {
      dispatch(setLocation("/create-bulk-campaign"));
    }
    onFinish();
  }, [bundleOptionType, dispatch, onFinish]);

  const allowedPromotionTypes = bundlePromotionTypes?.filter((option) => {
    if (option.value === EPromotionTypes.FREE_GIFT && storeId) {
      return freeGiftCountries?.includes(storeId);
    }
    return true;
  });

  return (
    <Card
      padding="0 30px 30px 30px"
      minWidth={["100%", "450px", "450px", "450px"]}
    >
      <Box display="flex" width="100%">
        <Select
          testId="bundle-selection-select"
          options={allowedPromotionTypes}
          label="Please Select Bundle Campaign Type"
          variant="native"
          onNativeChange={onChangeCampaignType}
          nativeValue={bundleOptionType}
          fontSize="14px"
          width="100%"
          size="medium"
          disableUnderline={false}
        />
      </Box>
      <Button
        data-testid="bundle-selection-button"
        round
        color="primary"
        variant="contained"
        margin="25px 0"
        width="100%"
        type="button"
        onClick={onNextHandler}
        disabled={!bundleOptionType}
      >
        Continue
      </Button>
    </Card>
  );
};

export default SelectBundleOptions;
